import { IconButton, Flex, XIcon } from '@buffer-mono/popcorn'

import { isRecentItem } from '../../../linkedin-annotations/queries/recentSuggestions'
import type { AutocompleteItem } from '../../types'

import styles from './AutocompleteSuggestion.module.css'

import type { JSX } from 'react'

export const AutocompleteSuggestion = ({
  mention,
  onRemoveRecentItem,
}: {
  mention: AutocompleteItem
  onRemoveRecentItem?: (key: string) => void
}): JSX.Element => {
  const { avatar, name, handle } = mention.data

  const isRecentSuggestion = isRecentItem(mention.key)

  return (
    <Flex fullWidth align="center" justify="between">
      {avatar ? (
        <img className={styles.avatar} src={avatar} alt="" />
      ) : (
        <div className={styles.emptyAvatar}>{name ? name[0] : ''}</div>
      )}
      <span className={styles.text}>
        {name && <span className={styles.name}>{`${name} `}</span>}
        {handle}
      </span>

      {isRecentSuggestion && onRemoveRecentItem && (
        <IconButton
          label="Remove recent suggestion"
          variant="tertiary"
          size="small"
          onMouseDown={(e): void => {
            e.preventDefault()
            e.stopPropagation()
            onRemoveRecentItem(mention.key)
          }}
        >
          <XIcon />
        </IconButton>
      )}
    </Flex>
  )
}
